import { render } from "./OurFeatures.vue?vue&type=template&id=321d81ab&ts=true"
import script from "./OurFeatures.vue?vue&type=script&lang=ts"
export * from "./OurFeatures.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__